module.exports = __webpack_public_path__ + "img/img1.814fe95b.png";